import React from 'react';

import { type FWorkflowStepFragment, WorkflowStepStatus } from '@dashboard/generated/wp/platform';
import { ElectricBoltOutlined } from '@mui/icons-material';

import TemplateEventField from '../TemplateEventField';
import TemplateMessageField from '../TemplateMessageField';
import WorkflowCard from '../WorkflowCard';

import CardCaption from './CardCaption';
import TitleIcon from './TitleIcon';

type Props = {
  step: FWorkflowStepFragment;
};
export default function SendMarkdownEmailMessage({ step }: Props) {
  const renderChildren = () => {
    switch (step.status) {
      case WorkflowStepStatus.Succeeded:
        return <TemplateEventField emailMessageId={step.result!.sendMarkdownEmailMessage!.emailMessageId} />;
      case WorkflowStepStatus.Failed:
        if (step.errorMessage) {
          return <TemplateMessageField>{step.errorMessage}</TemplateMessageField>;
        }
        return <TemplateMessageField>There was an error processing this step.</TemplateMessageField>;
      case WorkflowStepStatus.Disabled:
        return <TemplateMessageField>This step was disabled on your workflow.</TemplateMessageField>;
      case WorkflowStepStatus.Processing:
        return <TemplateMessageField>This step is currently processing.</TemplateMessageField>;
      case WorkflowStepStatus.Pending:
      default:
        return null;
    }
  };
  return (
    <WorkflowCard
      titleIcon={<TitleIcon step={step} />}
      titleText="Send email"
      labelIcon={<ElectricBoltOutlined fontSize="small" />}
      labelText="Quick template"
      caption={<CardCaption step={step} />}
    >
      {renderChildren()}
    </WorkflowCard>
  );
}
